import axios from 'axios';
import { api } from './api.config';

import { ICurrentUser } from './../features/currentUser/currentUserSlice';

export const loginApi = async (data: {
  login: string;
  password: string;
}): Promise<Omit<ICurrentUser, 'roles'>> => {
  const response = await api.post(`auth-password/sign-in`, { ...data });
  return response.data;
};

export const checkPhoneApi = async (data: {
  phone: string;
  method?: 'phone' | 'email';
}): Promise<{ valid: boolean }> => {
  const response = await api.post(`auth-password/check-phone`, { ...data });
  return response.data;
};

export const checkCodeApi = async (data: {
  phone: string;
  mfaCode: number;
  method?: 'phone' | 'email';
}): Promise<{ valid: boolean }> => {
  const response = await api.post(`auth-password/check-code`, { ...data });
  return response.data;
};

export const signUpApi = async (data: {
  phone: string;
  password: string;
  mfaCode: number;
}): Promise<Omit<ICurrentUser, 'roles'>> => {
  const response = await api.post(`auth-password/sign-up`, { ...data });
  return response.data;
};

export const resetPasswordApi = async (data: {
  phone: string;
  password: string;
  mfaCode: number;
}): Promise<Omit<ICurrentUser, 'roles'>> => {
  const response = await api.post(`auth-password/change-password`, { ...data });
  return response.data;
};

export const checkTokenApi = async (): Promise<boolean> => {
  const response = await api.get(`auth-password/check-reset-password`);
  return response.data;
};

export const refreshApi = async (): Promise<Omit<ICurrentUser, 'refreshToken' | 'roles'>> => {
  const response = await api.get(`auth-password/refresh`);
  return response.data;
};

export const refreshWithToken = async (
  token: string
): Promise<Omit<ICurrentUser, 'refreshToken' | 'roles'>> => {
  const response = await axios.get(`${api.defaults.baseURL}/auth-password/refresh`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
